import React from 'react';

import InputTextarea from '../../../inputs/InputTextarea';
import InputImage from '../../../inputs/InputImage';
import InputError from '../../../inputs/InputError';
import ButtonPrimary from '../../../components/ButtonPrimary';

export default function Step2({
  className,
  values,
  errors,
  setValue,
  setDirty,
  nextStep,
  defaultImages
}) {
  return (
  <section className={`share__step-2 ${ className || '' }`}>
    <div className="mb24">
      <h3 className="fz25 fw500 mb16">
        Your Story
      </h3>
      <div className="h225">
        <InputTextarea
          name="content"
          value={values.content}
          setValue={setValue}
          setDirty={setDirty}
          minCharacters={500}
          disableAutoComplete={true}
        />
      </div>
      <InputError hasError={errors.contentRequiredError}>Please enter your story.</InputError>
      <InputError hasError={errors.contentLengthMinError}>Your story must be at least 500 characters.</InputError>
    </div>
    <div className="mb24">
      <h3 className="fz25 fw600 mb16">
        Lead Image
      </h3>
      <InputImage
        name="image1"
        value={values.image1}
        defaultValue={defaultImages[0]}
        setValue={setValue}
        setDirty={setDirty}
        hideUploadButton={true}
        hasError={errors.image1RequiredError}
      />
      <InputError hasError={errors.image1RequiredError}>Please upload an image.</InputError>
    </div>
    <div className="mb24">
      <div className="w330 h100 w100%@sm">
        <InputTextarea
          name="image1Description"
          labelText="Caption"
          maxCharacters={80}
          value={values.image1Description}
          setValue={setValue}
          setDirty={setDirty}
        />
      </div>
    </div>
    <div className="mb24">
      <h3 className="fz25 fw600 mb16 mt80">
        Gallery Images
      </h3>
      <div className="df fxww">
        <div className="step-2__image-2-wrapper mr40 mr0@sm mb80">
          <h3 className="fz16 fw600 mb16 ff-gr">
            Gallary Image 1
          </h3>
          <InputImage
            className="mb24"
            name="image2"
            value={values.image2}
            defaultValue={defaultImages[1]}
            setValue={setValue}
            setDirty={setDirty}
            hideUploadButton={true}
          />
          <div className="w330 h100 w100%@sm">
            <InputTextarea
              name="image2Description"
              labelText="Caption"
              maxCharacters={80}
              value={values.image2Description}
              setValue={setValue}
              setDirty={setDirty}
            />
          </div>
        </div>
        <div className="step-2__image-3-wrapper mr40 mr0@sm mb80">
          <h3 className="fz16 fw600 mb16 ff-gr">
            Gallary Image 2
          </h3>
          <InputImage
            className="mb24"
            name="image3"
            value={values.image3}
            defaultValue={defaultImages[2]}
            setValue={setValue}
            setDirty={setDirty}
            hideUploadButton={true}
          />
          <div className="w330 h100 w100%@sm">
            <InputTextarea
              name="image3Description"
              labelText="Caption"
              maxCharacters={80}
              value={values.image3Description}
              setValue={setValue}
              setDirty={setDirty}
            />
          </div>
        </div>
        <div className="step-2__image-4-wrapper mr40 mr0@sm mb80">
          <h3 className="fz16 fw600 mb16 ff-gr">
            Gallary Image 3
          </h3>
          <InputImage
            className="mb24"
            name="image4"
            value={values.image4}
            defaultValue={defaultImages[3]}
            setValue={setValue}
            setDirty={setDirty}
            hideUploadButton={true}
          />
          <div className="w330 h100 w100%@sm">
            <InputTextarea
              name="image4Description"
              labelText="Caption"
              maxCharacters={80}
              value={values.image4Description}
              setValue={setValue}
              setDirty={setDirty}
            />
          </div>
        </div>
        <div className="step-2__image-5-wrapper mr40 mr0@sm mb80">
          <h3 className="fz16 fw600 mb16 ff-gr">
            Gallary Image 4
          </h3>
          <InputImage
            className="mb24"
            name="image5"
            value={values.image5}
            defaultValue={defaultImages[4]}
            setValue={setValue}
            setDirty={setDirty}
            hideUploadButton={true}
          />
          <div className="w330 h100 w100%@sm">
            <InputTextarea
              name="image5Description"
              labelText="Caption"
              maxCharacters={80}
              value={values.image5Description}
              setValue={setValue}
              setDirty={setDirty}
            />
          </div>
        </div>
      </div>
    </div>
    <div className="mb24 df jcfe">
      <ButtonPrimary onClick={nextStep}>
        Next
      </ButtonPrimary>
    </div>
    <InputError
      className="tar mb24"
      hasError={
         errors.contentRequiredError
      || errors.contentLengthMinError
      || errors.image1RequiredError
      }
    >
      This part of the form has errors.
    </InputError>
  </section>
  );
}
